export const ActionTypes = {
  GET_TOTAL_INCOME_AMOUNT: 'GET_TOTAL_INCOME_AMOUNT',
  EXPORT_TOTAL_INCOME_AMOUNT: 'EXPORT_TOTAL_INCOME_AMOUNT',
};
